export default {"src":"/_next/static/media/fDai.5ed24971.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};